import { useParams } from "react-router-dom";

const ImageViewer = () => {
  const { id } = useParams();

  return (
    <div style={{ margin: 0, padding: 0 }}>
      <img
        src={`/files/${id}.png`}
        alt="QR Result"
        style={{
          width: "100vw",
          height: "100vh",
          objectFit: "contain" // or "cover"
        }}
      />
    </div>
  );
};

export default ImageViewer;